
		export default class PageState{
			//模板生成============================================================================
			self:any = null;
			title: string = "";
			//============================================================================
      // currSpeaker:any = null;
      // allSpeakersMap: any = {};
      // emotionListMap: any = {};
		}